<script>
    let cls = "sui-form";
    export let layout = "horizontal";
</script>

<form class={`${cls} ${layout}`}>
    <div class={`${cls}-inner`}>
        <slot><!-- optional fallback --></slot>
    </div>
</form>

<style lang="less">
    @import "./form.less";
</style>
